import React from "react";
import { Image, SaveProgress } from "components";
import { H1, LineButton, Hr, Grid, GridItem, Button } from "appStyles";
import { imageView } from "defaultStates";
import { borderContainer } from "../editTemplate.styles";
import Modal from "@material-ui/core/Modal";
import AddCircleIcon from "@material-ui/icons/AddCircle";

const EditRotatingImageGalleryComponent = (props) => {
  const updateImage = (idx) => (image) => {
    const updatedComponent = {
      ...props.component,
    };

    updatedComponent.view.images[idx].url = image;
    props.updateComponent(updatedComponent);
  };

  const removeImage = (idx) => () => {
    const updatedComponent = {
      ...props.component,
    };
    updatedComponent.view.images.splice(idx, 1);
    props.updateComponent(updatedComponent);
  };

  const addNewImage = () => {
    const updatedComponent = {
      ...props.component,
    };
    updatedComponent.view.images.push(imageView());
    props.updateComponent(updatedComponent);
  };

  const setClickAction = (idx) => (templateId) => {
    const updatedComponent = {
      ...props.component,
    };
    updatedComponent.view.images[idx].clickAction = {
      type: "templateSegue",
      templateId: parseInt(templateId),
    };
    props.updateComponent(updatedComponent);
  };

  const { appId, component, activeApp, onClose } = props;
  const { view } = component;

  return (
    <div>
      <Modal
        open={true}
        disableAutoFocus={true}
        onClose={() => onClose(null)}
        style={{
          top: "15%",
          width: "80%",
          marginLeft: "auto",
          marginRight: "auto",
        }}
      >
        <div
          style={{
            width: "85%",
            boxShadow: "6px 7px 5px -2px #c2baba",
            border: "1px solid #c2baba",
            height: "550px",
            padding: "1em",
            background: "white",
            overflowY: "auto",
            margin: "inherit",
          }}
        >
          <H1 style={{ marginBottom: "15px" }}>Upload Images</H1>
          <Grid columns="2">
            {view.images.map((image, idx) => {
              return (
                <GridItem
                  key={idx}
                  margin="0px"
                  width="250px"
                  height="auto"
                  background="none"
                >
                  <Image
                    height="9em"
                    width="auto"
                    editMode={true}
                    imageUrl={image.url}
                    removeImage={removeImage(idx)}
                    uploadImage={updateImage(idx)}
                    displayLabel={"none"}
                    displayImage={"inline-block"}
                  />
                </GridItem>
              );
            })}
          </Grid>

          <Hr />
          <div
            style={{
              display: "flex",
              marginTop: "25px",
              justifyContent: "space-between",
            }}
          >
            <Button
              onClick={addNewImage}
              style={{
                marginLeft: " 0px",
                display: "inline-flex",
                alignItems: "center",
                textAlign: "center",
                fontSize: "15px",
                lineHeight: "29px",
                borderRadius: "5.5px",
                backgroundColor: "#89d2d3",
                fontWeight: "bold",
                boxShadow: "3px 3px 13px rgba(120, 120, 120, 0.5)",
                fontStyle: "normal",
                fontStretch: "normal",
                textTransform: "none",
              }}
            >
              <AddCircleIcon style={{ marginRight: "5px" }}></AddCircleIcon>
              Add New Image
            </Button>
            <SaveProgress />
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default EditRotatingImageGalleryComponent;
